import React from "react";

const Paginate = ({ total, setPage, page }) => {
  const pages = Math.ceil(total / 10);
  const goRef = React.useRef(null);
  function changeCurrent(n) {
    if (n > 0 && n <= pages) {
      setPage(n);
      goRef.current.value = n;
    }
  }
  React.useEffect(() => {
    goRef.current.value = page;
  });

  return (
    <div className="text-center mt-3">
      <p className="mb-1">
        Showing Page <span className="fw-bold">{page}</span> of {pages}
      </p>
      <div className="btn-group" role="group">
        <button
          type="button"
          className="btn btn-outline-primary"
          disabled={page <= 1}
          onClick={() => changeCurrent(page - 1)}
        >
          Prev Page
        </button>
        <button
          type="button"
          className="btn btn-outline-primary"
          disabled={page >= pages}
          onClick={() => changeCurrent(page + 1)}
        >
          Next Page
        </button>
      </div>
      <div className="btn-group ms-2">
        <input
          type="number"
          className="form-control flex-grow-0 rounded-0 rounded-start"
          style={{ width: "75px" }}
          ref={goRef}
          placeholder="1"
          min={1}
          max={pages}
        />
        <button
          type="button"
          className="btn btn-outline-secondary"
          type="button"
          onClick={() => changeCurrent(Number(goRef.current.value))}
        >
          Go
        </button>
      </div>
    </div>
  );
};

export default Paginate;
